// extracted by mini-css-extract-plugin
export default {"container":"H_-z","list":"I_-z"};